import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'StateInput' })(() => ({
  stateContainer: {
    paddingBottom: 'var(--ebl-s3)',
  },
  input: {
    background: 'initial',
    backgroundColor: 'white',
  },
}));
